import {DropDownGroup, DropDownGroupBy, DropDownGroupedBy, DropDownItem} from "../../models/general/dropdownItem.model";

export const groupDropdownOptions = (options: DropDownItem[], groupBy: DropDownGroupBy): DropDownGroup => {
    let result: DropDownItem[] = [];
    const groups: { [key: string]: DropDownItem[] } = {};

    // Group items
    for (const option of options) {
        const group = groupBy.group(option, options) || '';
        if (!groups[group]) {
            groups[group] = [option];
        } else {
            groups[group].push(option);
        }
    }

    // Sort items inside each group safely
    for (const key in groups) {
        groups[key].sort((a, b) =>
            (a.name || '').localeCompare(b.name || '', 'en', { sensitivity: 'base', numeric: true })
        );
    }

    // Create grouped array and sort groups in a cross-browser consistent way
    const grouped: DropDownGroupedBy[] = Object.entries(groups).map(group => {
        return {group: group[0], options: group[1]}
    }).sort(
        (a, b) => (a.group || '').localeCompare(b.group || '', 'en', { sensitivity: 'base', numeric: true })
    );

    if (grouped.length > 0) {
        grouped.forEach(group => {
            const label = groupBy.label(group, grouped.filter(g => groupBy.display(g)));
            const display = groupBy.display(group, grouped);
            if ((label?.display) && display) {
                const groupOption: DropDownItem = {
                    textAsync: label.textAsync,
                    isGroup: true,
                    id: 0
                }
                result.push(...[groupOption, ...group.options]);
            } else if (display) {
                result.push(...group.options);
            }
        });
    } else {
        result.push(...options);
    }

    return {hasGroups: grouped.length > 0, hasMultiGroups: grouped.length > 1, options: result};
}
